import { render } from "./Cronometro.vue?vue&type=template&id=0119aed4&ts=true"
import script from "./Cronometro.vue?vue&type=script&lang=ts"
export * from "./Cronometro.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__